webpackJsonp([1],{

/***/ "+23j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__ = __webpack_require__("oV5H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c4845a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__ = __webpack_require__("8pV8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48c4845a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+9qk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_js__ = __webpack_require__("ueVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    savedData: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    hasError: {
      type: Boolean,
      default: false
    },
    fandoms: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxChars: {
      type: Number,
      default: 4
    },
    number: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      msg: '',
      term: '',
      fandom: {},
      chars: [],
      options: [],
      selectedIndex: -1,
      charsLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({ characters: 'characters', allFandoms: 'fandoms' })),
  watch: {
    term: function term(val, oldVal) {
      if (val !== oldVal) {
        this.selectedIndex = -1;
        this.msg = null;
      }
    },

    chars: {
      deep: true,
      handler: function handler() {
        this.update();
      }
    },
    fandom: {
      deep: true,
      handler: function handler() {
        this.update();
      }
    },
    savedData: {
      deep: true,
      handler: function handler() {
        this.loadSaved();
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.savedData !== null) {
      this.loadSaved();
    }
  },

  methods: {
    loadSaved: function loadSaved() {
      this.chars = this.savedData.characters || [];
      this.fandom = this.allFandoms[this.savedData.key];
      this.autocomplete();
    },
    update: function update() {
      this.$emit('update', {
        fandom: {
          name: this.fandom.name,
          '.key': this.fandom['.key']
        },
        characters: this.chars
      });
    },
    autocomplete: function autocomplete(type) {
      var _this = this;

      if (this.chars.length === this.maxChars) {
        this.msg = 'You cannot select any more characters!';
        return;
      }
      if (!this.term.length && !this.fandom.name) {
        this.options = [];
        return;
      }

      if (!this.fandom.name) {
        this.options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.fandoms, function (o) {
          return o.name.toLowerCase().indexOf(_this.term.toLowerCase()) > -1;
        });
        return;
      } else {
        var fandomKey = this.fandom['.key'];
        var results = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.characters[fandomKey], function (o) {
          if (!o) {
            o = '';
          }
          return o.toLowerCase().indexOf(_this.term.toLowerCase()) > -1;
        });

        this.options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.difference(results, this.chars) || [];
      }
    },
    removeFandom: function removeFandom() {
      this.fandom = '';
      this.chars = [];
      this.options = [];
      this.selectedIndex = -1;
      this.term = '';
      this.msg = '';
    },
    removeChar: function removeChar(char) {
      this.chars = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.chars, function (o) {
        return o !== char;
      });

      this.term = ''; // reset the search to be explicit
      this.msg = '';

      this.options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.difference(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toArray(this.characters[this.fandom['.key']]), this.chars);
    },
    highlight: function highlight(option, type) {
      if (!option) {
        return;
      }
      // highlight any char
      var regex = new RegExp(this.term, 'ig');
      return option.replace(regex, '<strong>$&</strong>');
    },
    select: function select(type) {
      var _this2 = this;

      if (this.selectedIndex < 0 || this.selectedIndex > this.options.length - 1) {
        this.msg = 'You must select from the available options!';
        return;
      }

      if (type !== 'char') {
        this.show = null;
        this.fandom = this.options[this.selectedIndex];
        this.term = '';
        var fandomKey = this.fandom['.key'];
        this.options = [];

        if (!this.characters[fandomKey]) {
          this.charsLoading = true;

          __WEBPACK_IMPORTED_MODULE_2__db_js__["a" /* default */].ref('/characters/' + fandomKey).once('value').then(function (res) {
            var result = res.toJSON();
            _this2.$store.commit('addChar', { key: fandomKey, result: result });

            _this2.options = result || [];
            _this2.charsLoading = false;
          });
        } else {
          this.options = this.characters[fandomKey] || [];
        }
        return;
      }

      this.chars.push(this.options[this.selectedIndex]);
      this.term = '';
      this.options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.difference(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toArray(this.characters[this.fandom['.key']]), this.chars);
    },
    next: function next() {
      if (this.selectedIndex === this.options.length - 1) {
        return;
      }
      this.selectedIndex++;
    },
    prev: function prev() {
      if (this.selectedIndex <= 0) {
        this.selectedIndex = -1;
      }
      this.selectedIndex--;
    }
  }
});

/***/ }),

/***/ "/wb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookmarks_vue__ = __webpack_require__("r5+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f918c898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bookmarks_vue__ = __webpack_require__("A+bj");
function injectStyle (ssrContext) {
  __webpack_require__("y0XD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f918c898"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookmarks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f918c898_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_bookmarks_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4x5c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fandom_autocomplete_vue__ = __webpack_require__("7RSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__db_js__ = __webpack_require__("ueVu");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FandomAutocomplete: __WEBPACK_IMPORTED_MODULE_5__fandom_autocomplete_vue__["a" /* default */]
  },
  firebase: {
    letters: __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letters')
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.availableFandoms = this.fandoms;
  },
  data: function data() {
    return {
      errors: [],
      max: 6,
      min: 3,
      username: '',
      selectedFandoms: [],
      scrubbedFandoms: [],
      isPinchhitter: false,
      url: '',
      isReview: false,
      availableFandoms: [],
      userExists: false,
      userKey: '',
      userData: {},
      userMeta: {},
      unlocked: false,
      error: '',
      success: false,
      showSubmit: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['fandoms']), {
    submitText: function submitText() {
      if (this.isReview) {
        return 'Submit!';
      }

      return 'Preview!';
    }
  }),
  methods: {
    // https://stackoverflow.com/questions/8667070/javascript-regular-expression-to-validate-url
    validateUrl: function validateUrl(value) {
      return (/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value)
      );
    },
    deleteLetter: function deleteLetter() {
      var _this = this;

      if (!confirm('Are you sure you want to delete your letter?')) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(this.username).remove();

      this.scrubFandoms();
      _.each(this.scrubbedFandoms, function (req) {
        _this.$firebaseRefs.letters.child(req.fandom['.key']).child(_this.username).remove();
      });

      this.$emit('close');
    },
    submit: function submit() {
      this.errors = [];
      this.scrubFandoms();

      if (this.isReview) {
        this.add();
        return;
      }

      if (!this.username.length) {
        this.errors.push('username');
      }

      if (!this.url.length || !this.validateUrl(this.url)) {
        this.errors.push('url');
      }

      if (!this.isPinchhitter && this.scrubbedFandoms.length < this.min) {
        this.errors.push('fandom');
      }

      if (this.errors.length) {
        return;
      }

      this.isReview = true;
    },
    scrubFandoms: function scrubFandoms() {
      // put things into a separate array so that index order is preserved
      // if users want to go back and edit
      this.scrubbedFandoms = _.compact(_.filter(this.selectedFandoms, function (f) {
        return f !== null && f !== undefined;
      }));
    },
    edit: function edit() {
      this.isReview = false;
    },
    hasError: function hasError(type) {
      return _.includes(this.errors, type);
    },
    update: function update(index, data) {
      var newVal = this.selectedFandoms;

      if (!data.fandom || !data.fandom.name) {
        newVal[index] = null;
      } else {
        newVal[index] = data;
      }

      this.selectedFandoms = [];
      this.selectedFandoms = newVal;

      var selected = [];

      _.each(this.selectedFandoms, function (o) {
        if (!o) {
          return;
        }
        selected.push(o.fandom['.key']);
      });

      this.availableFandoms = _.filter(this.fandoms, function (o) {
        return !_.includes(selected, o['.key']);
      });
    },
    loadUser: function loadUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(this.username).once('value').then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          var user, _loop, key;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  user = res.val();

                  if (user) {
                    _context3.next = 5;
                    break;
                  }

                  _this2.error = 'Could not find a letter for this username. Check case-sensitivity!';
                  _context3.next = 20;
                  break;

                case 5:
                  if (!(user.key !== _this2.userKey)) {
                    _context3.next = 9;
                    break;
                  }

                  _this2.error = 'Wrong letter key!';
                  _context3.next = 20;
                  break;

                case 9:
                  _this2.userData = user.fandoms;
                  _this2.userMeta = { username: _this2.username, key: user.key, timestamp: user.timestamp };

                  // load the character lists
                  _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(key) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/characters/' + key).once('value').then(function () {
                              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                                var result;
                                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        result = res.toJSON();

                                        _this2.$store.commit('addChar', { key: key, result: result });

                                      case 2:
                                      case 'end':
                                        return _context.stop();
                                    }
                                  }
                                }, _callee, _this2);
                              }));

                              return function (_x2) {
                                return _ref2.apply(this, arguments);
                              };
                            }());

                          case 2:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _loop, _this2);
                  });
                  _context3.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(user.fandoms);

                case 13:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 18;
                    break;
                  }

                  key = _context3.t1.value;
                  return _context3.delegateYield(_loop(key), 't2', 16);

                case 16:
                  _context3.next = 13;
                  break;

                case 18:
                  _this2.url = _this2.userData[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.userData)[0]].url;

                  _this2.unlocked = true;

                case 20:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getCopypasta: function getCopypasta() {
      if (!this.scrubbedFandoms.length) {
        return;
      }

      var pasta = ['<p><strong>' + this.username + '</strong><br>' + this.url + '</p>'];

      _.each(this.scrubbedFandoms, function (f) {
        var fandom = f.fandom;
        var chars = f.characters;
        if (!chars.length) {
          chars = ['Any (see tagset)'];
        }
        var s = '<p><strong>' + fandom.name + '</strong><br>' + chars.join(', ') + '</p>';
        pasta.push(s);
      });

      return pasta.join('\n');
    },
    add: function add() {
      var _this3 = this;

      // if the username got edited, delete the old one
      // and create a new one that maintains the right metadata
      if (this.username !== this.userMeta.username) {
        __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(this.userMeta.username).remove();

        _.each(this.userData, function (f) {
          _this3.$firebaseRefs.letters.child(f.key).child(_this3.userMeta.username).remove();
        });

        __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(this.username).set({ key: this.userMeta.key, timestamp: this.userMeta.timestamp });
      }
      // clean out the user's fandom references
      __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(this.username).child('fandoms').remove();
      // write any updates
      _.each(this.scrubbedFandoms, function (req) {
        _this3.$firebaseRefs.letters.child(req.fandom['.key']).child(_this3.username).set({
          username: _this3.username,
          url: _this3.url,
          characters: req.characters,
          isPinchhitter: _this3.isPinchhitter || false
        });

        __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(_this3.username).child('fandoms').child(req.fandom['.key']).set({
          url: _this3.url,
          key: req.fandom['.key'],
          characters: req.characters,
          isPinchhitter: _this3.isPinchhitter || false
        });
      });

      // delete any removes
      var newFandoms = _.map(this.scrubbedFandoms, function (f) {
        return f.fandom['.key'];
      });
      var oldFandoms = _.map(this.userData, function (f) {
        if (!f) {
          return;
        }
        return f.key;
      });
      var deletedFandoms = _.difference(oldFandoms, newFandoms);

      _.each(deletedFandoms, function (index) {
        _this3.$firebaseRefs.letters.child(index).child(_this3.username).remove();
      });

      this.success = true;
      this.showSubmit = false;
    }
  }
});

/***/ }),

/***/ "6Jtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_options_vue__ = __webpack_require__("qSma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3678d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_options_vue__ = __webpack_require__("lHI4");
function injectStyle (ssrContext) {
  __webpack_require__("yRo+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c3678d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_options_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3678d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_options_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7PO5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"user-page"},[_c('div',{staticClass:"heading"},[_c('strong',[_vm._v(_vm._s(_vm.$route.params.id)+"'s")]),_vm._v(" prompts")]),_vm._v(" "),(_vm.userPrompts.length)?[_c('table',{staticClass:"prompts"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.userPrompts),function(prompt,i){return _c('tr',{key:i},[_c('td',[_vm._v("\n            "+_vm._s(prompt.fandom)+"\n          ")]),_vm._v(" "),_c('td',[(prompt.characters)?_c('ul',{staticClass:"characters"},_vm._l((prompt.characters),function(c,i){return _c('li',{key:i},[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"prompt"},[_c('div',{domProps:{"innerHTML":_vm._s(prompt.prompt)}}),_vm._v(" "),(prompt.letter)?_c('a',{attrs:{"href":_vm.formatUrl(prompt.letter),"target":"blank"}},[_vm._v("Letter")]):_vm._e()])])}))])]:_c('div',[_vm._v("User not found! Search is case-sensitive and preserves whitespace - maybe check your search and try again?.")])],2):_c('div',[_vm._v("Loading "+_vm._s(_vm.$route.params.id)+"'s prompts...")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"username"},[_vm._v("Fandom")]),_vm._v(" "),_c('th',{staticClass:"characters"},[_vm._v("Characters")]),_vm._v(" "),_c('th',{staticClass:"prompts"},[_vm._v("Prompts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7RSb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fandom_autocomplete_vue__ = __webpack_require__("+9qk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb6121d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fandom_autocomplete_vue__ = __webpack_require__("qAyU");
function injectStyle (ssrContext) {
  __webpack_require__("4x5c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eb6121d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fandom_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eb6121d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_fandom_autocomplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7myq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__("jyVo");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['userPrompts', 'user', 'promptmarks', 'options'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* default */], {
    close: function close() {
      this.$store.commit('setUser', null);
      this.$store.commit('setUserPrompts', []);
    }
  })
});

/***/ }),

/***/ "8/lm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_easter_eggs_vue__ = __webpack_require__("HUgf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e8cb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_easter_eggs_vue__ = __webpack_require__("vGNL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_easter_eggs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39e8cb88_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_easter_eggs_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "87u7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8pV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('h2',[_vm._v("FAQ")]),_vm._v(" "),_c('span',{staticClass:"close fas fa-times-circle",on:{"click":function($event){_vm.$emit('close')}}}),_vm._v(" "),_c('h3',[_vm._v("What is this?")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h3',[_vm._v("Does submitting a letter mean I'm signed up?")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',[_vm._v("Help! I lost my edit key!")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h3',[_vm._v("What? A nominated fandom isn't listed in the big table!")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',[_vm._v("What happened to the spreadsheet?")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('h3',[_vm._v("Tools: what does checking Mobile Letter Format do?")]),_vm._v(" "),_c('p',[_vm._v("Where possible, it gives you the \"most readable\" URLs for letters - e.g. mobile for Google Docs,\n       and Tumblr and DW/LJ light themes.\n    ")]),_vm._v(" "),_c('h3',[_vm._v("Letters: what does the \"Chars\" badge mean?")]),_vm._v(" "),_c('p',[_vm._v("It indicates the number of characters requested in the letter. Click on the badge and, if there are\n      characters requested, they will be bolded in the Characters column.\n    ")]),_vm._v(" "),_c('h3',[_vm._v("Bookmarks: How do bookmarks work?")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('h3',[_vm._v("I found a problem!")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("(Close)")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The app contains the tagset for Yuletide. Before assignments are released, participants can\n       submit their letter to this app for public listing, as is tradition! The letters post with more information is here on "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html","target":"blank"}},[_vm._v("DW")]),_vm._v(" and "),_c('a',{attrs:{"href":"https://yuletide.livejournal.com/1315417.html"}},[_vm._v("LJ")]),_vm._v(".\n      Once assignments go out, the full list of the prompts will be available as well.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("No")]),_vm._v(". You have to "),_c('a',{attrs:{"href":"http://archiveofourown.org/collections/yuletide2018/profile","target":"blank"}},[_vm._v("sign up for Yuletide on AO3")]),_vm._v(".\n    Conversely, you do not have to submit a letter to this app if you don't want to.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Hit up the "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html"}},[_vm._v("letters post")]),_vm._v(" ("),_c('a',{attrs:{"href":"https://yuletide.livejournal.com/1315417.html","target":"blank"}},[_vm._v("LJ version")]),_vm._v(") and ask a mod for help! You may also have luck finding a mod in Discord.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Fandoms are loaded in increments of 100 to save data. If you tried using your in-browser search (Ctrl-F), you may not have loaded enough fandoms! Use the in-app Filter By search box instead, or select Load All to load everything. Still not there even though it's in the official "),_c('a',{attrs:{"href":"https://archiveofourown.org/tag_sets/2592","target":"blank"}},[_vm._v("tagset")]),_vm._v("? Report a bug to the post on "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html","target":"blank"}},[_vm._v("DW")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://yuletide.livejournal.com/1315417.html","target":"blank"}},[_vm._v("LJ")]),_vm._v("!\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This app replaces the old spreadsheet, but for those who want this information in spreadsheet format, you can get a magically synced one (excluding characters for brevity) "),_c('a',{attrs:{"href":"https://docs.google.com/spreadsheets/d/10uywj4_eDDARH6ykh2uXB5yujfrAXnYa8Jhl-6vWB-Y/edit#gid=0","target":"blank"}},[_vm._v("here")]),_vm._v(". The sync happens every 5 minutes.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Click on a "),_c('span',{staticClass:"far fa-heart bookmark"}),_vm._v(" icon to bookmark something. Those become available\n    in the Bookmarks tab. You can bookmark fandoms, letters, and prompts (once available). An already-bookmarked thing\n    is denoted by a solid "),_c('span',{staticClass:"fas fa-heart bookmark"}),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Bookmarks are saved "),_c('em',[_vm._v("in your browser memory")]),_vm._v(",\n       so they should persist unless you clear your cache. However, that means you "),_c('strong',[_vm._v("cannot sync")]),_vm._v(" bookmarks\n       between browsers or devices.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Whether it's an app bug, a typo, a problem with the tagset, or an issue with a letter or prompt,\n      all problems should be reported to the letters post on "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html","target":"blank"}},[_vm._v("DW")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://yuletide.livejournal.com/1315417.html","target":"blank"}},[_vm._v("LJ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['bookmarks', { collapsed: !_vm.expand, large: _vm.largeBookmarks }]},[_c('div',{staticClass:"header"},[_c('span',{class:['fas expand', { 'fa-angle-double-right': _vm.expand, 'fa-angle-double-left': !_vm.expand }],on:{"click":function($event){_vm.expand = !_vm.expand; _vm.$emit('toggle')}}}),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Bookmarks "),(_vm.expand)?_c('span',{staticClass:"fas fa-question-circle",on:{"click":function($event){_vm.showHelp = !_vm.showHelp}}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"bookmarks-meta"},[(!_vm.expand)?_c('div',{staticClass:"counts"},[_c('ul',[_c('li',[_vm._v("\n          Letters: "+_vm._s(_vm.lettermarks.length)+"\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Fandoms: "+_vm._s(_vm.bookmarks.length)+"\n        ")]),_vm._v(" "),(_vm.unlock)?_c('li',[_vm._v("\n          Prompts: "+_vm._s(_vm.promptmarks.length)+"\n        ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.expand),expression:"expand"}],staticClass:"content"},[_c('div',{staticClass:"options"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.largeBookmarks),expression:"largeBookmarks"}],attrs:{"type":"checkbox","id":"expand-bookmarks"},domProps:{"checked":Array.isArray(_vm.largeBookmarks)?_vm._i(_vm.largeBookmarks,null)>-1:(_vm.largeBookmarks)},on:{"__c":function($event){var $$a=_vm.largeBookmarks,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.largeBookmarks=$$a.concat([$$v]))}else{$$i>-1&&(_vm.largeBookmarks=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.largeBookmarks=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"expand-bookmarks"}},[_vm._v("Make this wider")])]),_vm._v(" "),(_vm.showHelp)?_c('p',[_vm._v("You can bookmark fandoms, letters, and - when they become available after Madness - individual\n      prompts by clicking on the "),_c('span',{staticClass:"far fa-heart"}),_vm._v(" icon. This data is saved in your browser,\n      and will remain for as long as you do not clear the cache.\n    ")]):_vm._e(),_vm._v(" "),_c('p',[_c('a',{staticClass:"show-load",on:{"click":function($event){_vm.showLoad = !_vm.showLoad}}},[_vm._v("\n        "+_vm._s(_vm.showLoad ? 'Hide' : 'Show')+" Backup/Load\n      ")])]),_vm._v(" "),(_vm.showLoad)?_c('div',{staticClass:"load-wrapper"},[_c('div',{staticClass:"load-info"},[_c('p',[_vm._v("To transfer your bookmarks between browsers or computers, copy "),_c('em',[_vm._v("exactly")]),_vm._v(" the text in the \"Copy\" field. In the browser you want to load your bookmarks in, paste it into the \"Load\" field, then hit this button:\n          "),_c('button',{staticClass:"button-primary load",on:{"click":_vm.loadSaved}},[_vm._v("Load!")])])]),_vm._v(" "),_c('div',{staticClass:"area"},[_c('strong',[_vm._v("Copy:")]),_vm._v(" "),_c('textarea',{attrs:{"cols":"10","rows":"2"}},[_vm._v(_vm._s(_vm.marks))])]),_vm._v(" "),_c('div',{staticClass:"area"},[_c('strong',[_vm._v("Load:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.saved),expression:"saved"}],attrs:{"cols":"10","rows":"2"},domProps:{"value":(_vm.saved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.saved=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"letters"},[_c('h3',[_vm._v("Letters")]),_vm._v(" "),(_vm.lettermarks.length)?_c('ul',_vm._l((_vm.lettermarks),function(letter){return _c('li',{key:letter.url},[(letter.isPinchhitter)?[_vm._v("(")]:_vm._e(),_vm._v(" "),_c('a',{attrs:{"href":_vm.formatUrl(letter.url),"target":"_blank"}},[_vm._v(_vm._s(letter.username))]),_vm._v(" ("+_vm._s(letter.name)+")\n          "),(letter.isPinchhitter)?[_vm._v(")")]:_vm._e(),_vm._v(" "),_c('span',{staticClass:"remove far fa-times-circle",on:{"click":function($event){_vm.removeLettermark(letter)}}})],2)})):_c('span',[_vm._v("You haven't bookmarked any letters yet ):")])]),_vm._v(" "),_c('div',{staticClass:"fandoms"},[_c('h3',[_vm._v("Fandoms")]),_vm._v(" "),(_vm.bookmarksData.length)?_c('table',[_c('thead',[_c('tr',[_c('th',{staticClass:"fandom"},[_vm._v("Fandom")]),_vm._v(" "),(!_vm.options.hideCharacters)?_c('th',{staticClass:"characters"},[_vm._v("Characters")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"letters"},[_vm._v("Letters")]),_vm._v(" "),(_vm.unlock)?_c('th',{staticClass:"prompts"},[_vm._v("Prompts")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.bookmarksData),function(fandom,index){return _c('tr',{key:fandom.name,class:{ odd: index % 2 !== 0 }},[_c('td',{staticClass:"fandom"},[_vm._v("\n            "+_vm._s(fandom.name)+"\n            "),_c('span',{staticClass:"remove far fa-times-circle",on:{"click":function($event){_vm.remove(fandom)}}}),_vm._v(" "),_c('div',{staticClass:"meta"},[(!_vm.options.hideCategory)?_c('span',{staticClass:"category meta-tag"},[_vm._v(_vm._s(fandom.category.join(', ')))]):_vm._e()])]),_vm._v(" "),(!_vm.options.hideCharacters)?_c('td',{staticClass:"characters"},[_c('ul',_vm._l((_vm.getCharacters(fandom['.key'])),function(char){return _c('li',{key:char,class:{ highlight: _vm.letterHasChar(fandom['.key'], char) }},[_vm._v("\n                "+_vm._s(char)+"\n              ")])}))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"letters"},_vm._l((_vm.letters[fandom['.key']]),function(letter){return _c('ul',{key:letter.username},[_c('li',{staticClass:"letter"},[_c('a',{staticClass:"user",attrs:{"href":_vm.formatUrl(letter.url),"target":"_blank"}},[_vm._v(_vm._s(letter.username))]),_vm._v(" "),_c('button',{staticClass:"bookmark-letter",on:{"click":function($event){_vm.toggleLettermark(letter, fandom)}}},[(_vm.hasLettermark(letter, fandom))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})]),_vm._v(" "),_c('div',{staticClass:"meta"},[(_vm.isProlific(letter.username))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showEasterEggs)?_c('sup',[_vm._v(_vm._s(_vm.challenges(letter.username).join(' ')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"char-count meta-tag",on:{"click":function($event){_vm.highlightChars(letter, fandom['.key'])},"mouseleave":function($event){_vm.letterChars = []}}},[_vm._v("\n                      Chars: "+_vm._s(letter.characters === undefined ? 'Any' : letter.characters.length)+"\n                    ")])])])])})),_vm._v(" "),(_vm.unlock)?_c('td',{staticClass:"prompts"},[(!_vm.prompts[fandom['.key']] && _vm.hasPrompts[fandom['.key']])?_c('button',{staticClass:"button-primary",on:{"click":function($event){_vm.getPrompts( fandom['.key'])}}},[_vm._v("Get Prompts")]):_vm._e(),_vm._v(" "),(_vm.prompts[fandom['.key']] === 'loading')?_c('div',[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.prompts[fandom['.key']] && _vm.prompts[fandom['.key']].length && _vm.prompts[fandom['.key']] !== 'loading')?[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.collapse(_vm.prompts[fandom['.key']].length, $event)}}},[_vm._v("Collapse")]),_vm._v(" "),_c('table',{staticClass:"prompts"},[_vm._m(0,true),_vm._v(" "),_c('tbody',_vm._l((_vm.prompts[fandom['.key']]),function(prompt){return _c('tr',[_c('td',[_c('button',{staticClass:"bookmark",on:{"click":function($event){_vm.togglePromptmark(prompt)}}},[(_vm.hasPromptmark(prompt))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})])]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(prompt.username)+"\n                      "),(_vm.isProlific(prompt.username))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showEasterEggs)?_c('sup',[_vm._v(_vm._s(_vm.challenges(prompt.username).join(' ')))]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.getUserPrompts(prompt.username)}}},[_vm._v(" (see all)")])]),_vm._v(" "),_c('td',[(prompt.characters)?_c('ul',_vm._l((prompt.characters),function(c){return _c('li',[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"prompt"},[_c('div',{domProps:{"innerHTML":_vm._s(prompt.prompt)}}),_vm._v(" "),(prompt.letter)?_c('a',{attrs:{"href":_vm.formatUrl(prompt.letter),"target":"blank"}},[_vm._v("Letter")]):_vm._e()])])}))])]:_vm._e(),_vm._v(" "),(!_vm.hasPrompts[fandom['.key']])?_c('span',[_vm._v("No prompts ):")]):_vm._e()],2):_vm._e()])})],2):_c('span',[_vm._v("You haven't bookmarked any fandoms yet ):")])]),_vm._v(" "),(_vm.unlock)?[_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Prompts")]),_vm._v(" "),(_vm.promptmarks.length)?_c('div',[_c('strong',[_vm._v("Prompts:")]),_vm._v(" "),_c('table',{staticClass:"prompts"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.promptmarks),function(prompt){return _c('tr',[_c('td',[_c('button',{staticClass:"bookmark",on:{"click":function($event){_vm.togglePromptmark(prompt)}}},[(_vm.hasPromptmark(prompt))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})])]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(prompt.username)+"\n                  "),(_vm.isProlific(prompt.username))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showEasterEggs)?_c('sup',[_vm._v(_vm._s(_vm.challenges(prompt.username).join(' ')))]):_vm._e()]),_vm._v(" "),_c('td',[(prompt.characters)?_c('ul',{staticClass:"characters"},_vm._l((prompt.characters),function(c){return _c('li',[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"prompt"},[_c('div',{domProps:{"innerHTML":_vm._s(prompt.prompt)}}),_vm._v(" "),(prompt.letter)?_c('a',{attrs:{"href":_vm.formatUrl(prompt.letter),"target":"blank"}},[_vm._v("Letter")]):_vm._e()])])}))])]):_c('span',[_vm._v("You haven't bookmarked any prompts yet ):")])]:_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"fave"},[_vm._v("♥")]),_vm._v(" "),_c('th',{staticClass:"username"},[_vm._v("Username")]),_vm._v(" "),_c('th',{staticClass:"characters"},[_vm._v("Characters")]),_vm._v(" "),_c('th',{staticClass:"prompts"},[_vm._v("Prompts")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"fave"},[_c('span',{staticClass:"fas fa-heart"})]),_vm._v(" "),_c('th',{staticClass:"username"},[_vm._v("Username")]),_vm._v(" "),_c('th',{staticClass:"characters"},[_vm._v("Characters")]),_vm._v(" "),_c('th',{staticClass:"prompts"},[_vm._v("Prompts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DSBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROLIFIC_WRITERS; });
/* unused harmony export CRUELTIDE */
/* unused harmony export YULEPORN */
/* unused harmony export FESTIVUS */
var PROLIFIC_WRITERS = ['alley_skywalker', 'arbitrarily', 'arithanas', 'assimbya', 'astrokath', 'beatrice_otter', 'betony', 'brutti_ma_buoni', 'carolinecrane', 'chibifukurou', 'chicafrom3', 'chokolattejedi', 'cjmarlowe', 'damkianna', 'donutsweeper', 'escritoireazul', 'esteliel', 'estirose', 'eustaciavye', 'executrix', 'fabrisse', 'finch', 'flipflop_diva', 'fresne', 'greerwatson', 'halotolerant', 'haywire', 'htbthomas', 'innie', 'joanne_c', 'kalypsobean', 'karanguni', 'katayla', 'keerawa', 'laughingpineapple', 'lightningwaltz', 'longwhitecoats', 'mardia', 'marks', 'measured_words', 'merryghoul', 'miss_m', 'misura', 'mithen', 'mithrigil', 'nary', 'nightsmistress', 'nomadicwriter', 'plinys', 'primeideal', 'prosodiical', 'psychomachia', 'russian_blue', 'sadlikeknives', 'sarren', 'settiai', 'sevenofspade', 'skazka', 'spock', 'sumi', 'the_alchemist', 'thedevilchicken', 'tlvop', 'tuesday', 'voleuse', 'yhlee (etothey)'];
var CRUELTIDE = ['comixologist', 'red_terra', 'prodigy', 'keerawa', 'gaialux', 'vampirepaladin', 'scribe_of_mirrormere', 'merryghoul', 'falsteloj', 'evilmuffins', 'skazka', 'ahavah', 'blahblahwhy', 'apricot', 'effectaffect', 'notearchiver', 'russian_blue', 'alchemise', 'spock', 'ideallyqualia', 'havisham', 'days4daisy', 'reeby10', 'tristesses', 'radioqueen', 'derogatory', 'amyfortuna', 'esteliel', 'calliopes_pen', 'aeriel', 'dancingsalome', 'snowynight', 'geckoholic', 'soundandcolor', 'corik', 'tuesday', 'shadow_lover', 'starlatine', 'plinys', 'republic', 'the_wavesinger', 'makiyakinabe', 'the_alchemist', 'skitz_phenom', 'this', 'bonster', 'naughtyanne', 'kutsushita', 'applebutter', 'originally', 'major', 'laylah'];
var YULEPORN = ['effectaffect', 'rubylily', 'miss_terra', 'caudipteryx', 'scribe_of_mirrormere', 'laylah', 'skazka', 'days4daisy', 'airgiodslv', 'merryghoul', 'gayporwave', 'keerawa', 'tearoses', 'gaialux', 'scribblemyname', 'the_anglophile', 'extrapenguin', 'aunt_zelda', 'falsteloj', 'evilmuffins', 'aurilly', 'ahavah', 'apricot', 'sandrine', 'linndechir', 'comixologist', 'galerian_ash', 'croik', 'storiesfortravellers', 'theoldgods', 'spock', 'reeby10', 'the_plaid_slytherin', 'havisham', 'starlatine', 'lady_ganesh', 'dryad', 'tristesses', 'slr2moons', 'undomielregina', 'brampersandon', 'wiseorfool', 'hearteating', 'malkontent', 'blueteak', 'isis', 'amyfortuna', 'esteliel', 'coaldustcanary', 'deifire', 'geckoholic', 'carolinecrane', 'musyc', 'muccamukk', 'soundandcolor', 'tuesday', 'sath', 'radioqueen', 'shadow_lover', 'fairestcat', 'deepdarkwaters', 'toft', 'lilybeth84', 'novembersmith', 'atlanticslide', 'celeste9', 'halfeatenmoon', 'etnoe', 'doreyg', 'plinys', 'blue_eyesgirl_fic', 'republic', 'beedekka', 'hiddencait', 'hellabaloo', 'ozsaur', 'skitz_phenom', 'echoslammin', 'pajamasecrets', 'brigdh', 'trillingstar', 'spankedbyspike', 'kutsushita', 'jougetsu', 'weakinteraction', 'abluestocking', 'the_wavesinger', 'originally', 'rosedamask'];
var FESTIVUS = ['saiditallbefore', 'sath', 'keerawa', 'rubylily', 'tearoses', 'lionessvalenti', 'gayporwave', 'triplesalto', 'tekuates', 'chantefable', 'merryghoul', 'snowynight', 'muccamukk', 'mlraven', 'edonohana', 'starlatine', 'theoldgods', 'scioscribe', 'elwing_alcyone', 'hiddencait', 'yhlee (etothey)', 'ephemeralblossom', 'pyrophane', 'ideallyqualia', 'aunt_zelda', 'hauntedd', 'inkyrius', 'lalalalalawhy', 'idleflower', 'utsusemi', 'elfwreck', 'ahavah', 'shadaras', 'napkins', 'phidari', 'bygoshbygolly', 'alliterate', 'effectaffect', 'tristesses', 'snickfic', 'isis', 'glitterpig', 'sophiahelix', 'serenadestrong', 'deifire', 'malkontent', 'skazka', 'sineala', 'hyenateeth', 'tuesday', 'ambyr', 'basketofnovas (slashmarks)', 'azurish', 'impertinency', 'halfeatenmoon', 'hellabaloo', 'mapped', 'mammothluv', 'gramarye', 'rinadoll', 'zdenka', 'jougetsu', 'assimbya', 'shopfront', 'the_wavesinger', 'reconditarmonia', 'originally', 'minim_calibre'];



/***/ }),

/***/ "EKTE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('h2',[_vm._v("Submit Your Letter")]),_vm._v(" "),_c('span',{staticClass:"close fas fa-times-circle",on:{"click":function($event){_vm.$emit('close')}}}),_vm._v(" "),_c('p',[_vm._v("\n      Traditionally, participants in Yuletide may voluntarily submit their public Dear Author letters\n      to 'tide everyone through until all requests are made public after assignments go out.\n    ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReview),expression:"!isReview"}]},[_c('div',{class:['input username', { error: _vm.hasError('username')}]},[_c('label',{attrs:{"for":"username"}},[_vm._v("AO3 Username:")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"id":"username","type":"text","placeholder":"AO3 Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{class:['input link', , { error: _vm.hasError('url')}]},[_c('label',{attrs:{"for":"letter"}},[_vm._v("Letter Link:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"type":"text","id":"letter","placeholder":"Letter link - must be public!"},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input pher"},[_c('label',{attrs:{"for":"pher"}},[_vm._v("Pinch-hitter?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPinchhitter),expression:"isPinchhitter"}],attrs:{"type":"checkbox","name":"pher","id":"pher"},domProps:{"checked":Array.isArray(_vm.isPinchhitter)?_vm._i(_vm.isPinchhitter,null)>-1:(_vm.isPinchhitter)},on:{"__c":function($event){var $$a=_vm.isPinchhitter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPinchhitter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPinchhitter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPinchhitter=$$c}}}})]),_vm._v(" "),_c('div',_vm._l((_vm.max),function(i){return _c('fandom-autocomplete',{key:i,attrs:{"hasError":_vm.hasError('fandom'),"number":i,"fandoms":_vm.availableFandoms},on:{"update":function($event){_vm.update(i - 1, $event)}}})}))]),_vm._v(" "),(_vm.isReview && !_vm.userKey.length)?[(_vm.userExists)?_c('div',{staticClass:"error"},[_vm._v("This username has already submitted a letter to the app! Please edit it with your key. If you don't remember your key, contact a mod.")]):_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.username))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Letter Link")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.url))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Pinch-hitter?")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.isPinchhitter ? 'Yes' : ''))])]),_vm._v(" "),_vm._l((_vm.scrubbedFandoms),function(fandom,i){return _c('tr',{key:fandom.name},[_c('th',[_vm._v("Fandom "+_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(fandom.fandom.name))]),_vm._v(" "),_c('td',[_c('ul',{staticClass:"chars"},[(!fandom.characters.length)?_c('li',[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((fandom.characters),function(char){return _c('li',{key:char},[_vm._v(_vm._s(char))])})],2)])])})],2)])]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userKey.length),expression:"userKey.length"}]},[_c('hr',{staticClass:"separator"}),_vm._v(" "),_c('p',[_vm._v("\n        Your letter has been successfully submitted! Your letter key is\n        "),_c('strong',[_vm._v(_vm._s(this.userKey))]),_vm._v(" - NOTE THIS DOWN. You will need it if you want to edit your letter later.\n      ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('textarea',[_vm._v(_vm._s(_vm.getCopypasta()))]),_vm._v(" "),_c('p',[_vm._v("\n        Pssst, your letter is number\n        "),_c('strong',[_vm._v(_vm._s(_vm.number))]),_vm._v(" to be added!\n      ")])]),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:"error list"},[_c('p',[_vm._v("Uh oh, looks like you need to fix some things...")]),_vm._v(" "),_c('ul',[(_vm.hasError('username'))?_c('li',[_vm._v("You need a username")]):_vm._e(),_vm._v(" "),(_vm.hasError('url'))?_c('li',[_vm._v("You need a valid letter link (including the starting http!)")]):_vm._e(),_vm._v(" "),(_vm.hasError('fandom'))?_c('li',[_vm._v("You need at least "+_vm._s(_vm.min)+" fandoms")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showSubmit)?_c('button',{staticClass:"submit button-primary",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.submitText))]):_vm._e(),_vm._v(" "),(_vm.isReview && _vm.showSubmit)?_c('button',{staticClass:"submit button-warn",on:{"click":function($event){_vm.isReview = false}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("("+_vm._s(_vm.userKey.length ? 'Close' : 'Cancel')+")")])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Submitting your letter to the app does\n      "),_c('strong',[_vm._v("not count as signing up for Yuletide!")]),_vm._v("\n      Go and do that\n      "),_c('a',{attrs:{"href":"http://archiveofourown.org/collections/yuletide2018/profile","target":"blank"}},[_vm._v("on AO3")]),_vm._v(" between October 12 - 21.\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Here are your requests formatted in HTML so you can easily share them - may we suggest posting to the\n        "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html","target":"blank"}},[_vm._v("Letters Post")]),_vm._v("?\n      ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"notices small"},[_c('li',[_vm._v("Mods will delete any letter that is locked or breaks rules; your AO3 email will be sent a courtesy notice. You may resubmit a fixed letter at any time!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EolY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d88c26a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_caveats_vue__ = __webpack_require__("ghUD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d88c26a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_caveats_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G7wP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      findPal: '',
      pal: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['fandoms', 'showEasterEggs', 'letters']), {
    totalLetters: function totalLetters() {
      if (!this.letters) {
        return 'No data - database error!';
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.letters).length;
    }
  })
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var state = {
  loadedChars: false,
  loaded: false,
  loadAll: {
    characters: false,
    fandoms: false,
    letters: false
  },
  characters: {},
  fandoms: [],
  letters: {},
  prompts: {},
  bookmarks: [],
  lettermarks: [],
  promptmarks: [],
  user: null,
  userPrompts: [],
  categories: [],
  unlock: false,
  showEasterEggs: false,
  options: {
    filter: {
      category: '',
      term: ''
    },
    onlyLetters: false,
    onlyBookmarks: false,
    onlyPrompts: false,
    onlyPHs: false,
    destyle: false,
    hideCharacters: false
  }
};

var mutations = {
  addChar: function addChar(state, payload) {
    var old = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.characters).length;
    var newVal = state.characters;
    newVal[payload.key] = payload.result;
    state.characters = {};
    state.characters = newVal;
  },
  loadAllChars: function loadAllChars(state, val) {
    state.loadAll.characters = true;
  },
  setCharsLoaded: function setCharsLoaded(state, val) {
    state.loadedChars = true;
  },
  setCharacters: function setCharacters(state, characters) {
    state.characters = characters;
  },
  setLetters: function setLetters(state, letters) {
    state.letters = letters;
  },
  setDbLoaded: function setDbLoaded(state, val) {
    state.loaded = val;
  },
  setFandoms: function setFandoms(state, fandoms) {
    state.fandoms = fandoms;
  },
  setPrompts: function setPrompts(state, prompts) {
    state.prompts = prompts;
  },
  setPromptmarks: function setPromptmarks(state, promptmarks) {
    state.promptmarks = promptmarks;
  },
  setBookmarks: function setBookmarks(state, bookmarks) {
    state.bookmarks = bookmarks;
  },
  setLettermarks: function setLettermarks(state, lettermarks) {
    state.lettermarks = lettermarks;
  },
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setUserPrompts: function setUserPrompts(state, prompts) {
    state.userPrompts = prompts;
  },
  setCategories: function setCategories(state, categories) {
    state.categories = categories;
  },
  setOptions: function setOptions(state, options) {
    state.options = options;
  },
  setUnlock: function setUnlock(state, unlock) {
    state.unlock = unlock;
  },
  setEggs: function setEggs(state, val) {
    state.showEasterEggs = val;
  }
};

var getters = {
  loadAll: function loadAll(state) {
    return state.loadAll;
  },
  loadedChars: function loadedChars(state) {
    return state.loadedChars;
  },
  characters: function characters(state) {
    return state.characters;
  },
  letters: function letters(state) {
    return state.letters;
  },
  loaded: function loaded(state) {
    return state.loaded;
  },
  fandoms: function fandoms(state) {
    return state.fandoms;
  },
  prompts: function prompts(state) {
    return state.prompts;
  },
  categories: function categories(state) {
    return state.categories;
  },
  bookmarks: function bookmarks(state) {
    return state.bookmarks;
  },
  lettermarks: function lettermarks(state) {
    return state.lettermarks;
  },
  promptmarks: function promptmarks(state) {
    return state.promptmarks;
  },
  user: function user(state) {
    return state.user;
  },
  userPrompts: function userPrompts(state) {
    return state.userPrompts;
  },
  options: function options(state) {
    return state.options;
  },
  unlock: function unlock(state) {
    return state.unlock;
  },
  showEasterEggs: function showEasterEggs(state) {
    return state.showEasterEggs;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "L1D7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_lookup_vue__ = __webpack_require__("7myq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a5d79a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_user_lookup_vue__ = __webpack_require__("aMsF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_lookup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a5d79a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_user_lookup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa5477e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lGKn");
function injectStyle (ssrContext) {
  __webpack_require__("87u7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_daa5477e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__User__ = __webpack_require__("dVXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_index_js__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__db_js__ = __webpack_require__("ueVu");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











var metaRef = __WEBPACK_IMPORTED_MODULE_11__db_js__["a" /* default */].ref('/meta');

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]);

var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }, { path: '/user/:id', component: __WEBPACK_IMPORTED_MODULE_6__User__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_10_vue_router__["a" /* default */]({
  routes: routes
});

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_7__store_index_js__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  store: store,
  router: router,
  el: '#app',
  template: '<div><router-view></router-view></div>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]
  },
  watch: {
    letters: {
      deep: true,
      handler: function handler(val) {
        if (val && val['.value']) {
          store.commit('setLetters', val['.value']);
        } else {
          store.commit('setLetters', val);
        }
      }
    }
  },
  data: function data() {
    return {
      letters: {}
    };
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_11__db_js__["a" /* default */].ref('/characters').limitToFirst(100).once('value').then(function (res) {
      var result = res.toJSON();
      store.commit('setCharsLoaded', true);
      store.commit('setCharacters', result);
    });
    __WEBPACK_IMPORTED_MODULE_11__db_js__["a" /* default */].ref('/fandomsonly').once('value').then(function (res) {
      var result = res.val();
      store.commit('setDbLoaded', true);
      result = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(result, function (o, i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, o, {
          '.key': i
        });
      });
      store.commit('setFandoms', result);
      var categories = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(result, function (o) {
        if (!o) {
          return;
        }
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(o.category, function (cat) {
          if (!cat.length) {
            return;
          }
          categories.push(cat);
        });
      });
      store.commit('setCategories', __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(categories));
    });
  },

  firebase: {
    letters: {
      source: __WEBPACK_IMPORTED_MODULE_11__db_js__["a" /* default */].ref('/letters'),
      asObject: true,
      readyCallback: function readyCallback() {
        if (this.letters && this.letters['.value']) {
          store.commit('setLetters', this.letters['.value']);
        } else {
          store.commit('setLetters', this.letters);
        }
      }
    },
    meta: {
      source: metaRef
    }
  }
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: "AIzaSyDyJu1k-NNRmoK-eMq9l_hgr3cChgO-g_s",
  authDomain: "tagset2018.firebaseapp.com",
  databaseURL: "https://tagset2018.firebaseio.com",
  projectId: "tagset2018",
  storageBucket: "tagset2018.appspot.com",
  messagingSenderId: "689556051903"
});

/***/ }),

/***/ "TWSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('h2',[_vm._v("Edit Your Letter")]),_vm._v(" "),_c('span',{staticClass:"close fas fa-times-circle",on:{"click":function($event){_vm.success = false; _vm.$emit('close')}}}),_vm._v(" "),(!_vm.unlocked)?_c('div',{staticClass:"creds"},[_c('label',{attrs:{"for":"u"}},[_vm._v("Username:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"type":"text","id":"u","placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"key"}},[_vm._v("Letter Key:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userKey),expression:"userKey"}],attrs:{"type":"password","placeholder":"Your letter key...","id":"key"},domProps:{"value":(_vm.userKey)},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.loadUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.userKey=$event.target.value}}}),_vm._v(" "),(_vm.error.length)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"submit button-primary",on:{"click":_vm.loadUser}},[_vm._v("Let Me Edit!")])]):(!_vm.success)?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReview),expression:"!isReview"}]},[_c('div',{class:['input username', { error: _vm.hasError('username')}]},[_c('label',{attrs:{"for":"username"}},[_vm._v("AO3 Username:")]),_vm._v(" "),_c('input',{directives:[{name:"focus",rawName:"v-focus"},{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"id":"username","type":"text","placeholder":"AO3 Username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{class:['input link', , { error: _vm.hasError('url')}]},[_c('label',{attrs:{"for":"letter"}},[_vm._v("Letter Link:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.url),expression:"url"}],attrs:{"type":"text","id":"letter","placeholder":"Letter link - must be public!"},domProps:{"value":(_vm.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.url=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input pher"},[_c('label',{attrs:{"for":"pher"}},[_vm._v("Pinch-hitter?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isPinchhitter),expression:"isPinchhitter"}],attrs:{"type":"checkbox","name":"pher","id":"pher"},domProps:{"checked":Array.isArray(_vm.isPinchhitter)?_vm._i(_vm.isPinchhitter,null)>-1:(_vm.isPinchhitter)},on:{"__c":function($event){var $$a=_vm.isPinchhitter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isPinchhitter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isPinchhitter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isPinchhitter=$$c}}}})]),_vm._v(" "),_c('div',_vm._l((_vm.max),function(i){return _c('fandom-autocomplete',{key:i,attrs:{"hasError":_vm.hasError('fandom'),"number":i,"fandoms":_vm.availableFandoms,"saved-data":_vm.userData[Object.keys(_vm.userData)[i - 1]]},on:{"update":function($event){_vm.update(i - 1, $event)}}})}))]),_vm._v(" "),(_vm.isReview)?[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.username))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Letter Link")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.url))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Pinch-hitter?")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.isPinchhitter ? 'Yes' : ''))])]),_vm._v(" "),_vm._l((_vm.scrubbedFandoms),function(fandom,i){return _c('tr',[_c('th',[_vm._v("Fandom "+_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(fandom.fandom.name))]),_vm._v(" "),_c('td',[_c('ul',{staticClass:"chars"},[(!fandom.characters.length)?_c('li',[_vm._v("Any")]):_vm._e(),_vm._v(" "),_vm._l((fandom.characters),function(char){return _c('li',[_vm._v(_vm._s(char))])})],2)])])})],2)])]:_vm._e(),_vm._v(" "),(_vm.errors.length)?_c('div',{staticClass:"error list"},[_c('p',[_vm._v("Uh oh, looks like you need to fix some things...")]),_vm._v(" "),_c('ul',[(_vm.hasError('username'))?_c('li',[_vm._v("You need a username")]):_vm._e(),_vm._v(" "),(_vm.hasError('url'))?_c('li',[_vm._v("You need a valid letter link (including the starting http!)")]):_vm._e(),_vm._v(" "),(_vm.hasError('fandom'))?_c('li',[_vm._v("You need at least "+_vm._s(_vm.min)+" fandoms")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.showSubmit)?_c('button',{staticClass:"submit button-primary",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.submitText))]):_vm._e(),_vm._v(" "),(_vm.isReview && _vm.showSubmit)?_c('button',{staticClass:"submit button-warn",on:{"click":function($event){_vm.isReview = false}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(_vm.showSubmit)?_c('button',{staticClass:"submit button-warn",on:{"click":_vm.deleteLetter}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),_vm._m(0)]:_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}]},[_c('hr'),_vm._v("Your letter has been successfully edited!\n      "),_vm._m(1),_vm._v(" "),_c('textarea',[_vm._v(_vm._s(_vm.getCopypasta()))])]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.success = false; _vm.$emit('close')}}},[_vm._v("("+_vm._s(_vm.success ? 'Close' : 'Cancel')+")")])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"notices small"},[_c('li',[_vm._v("Mods will delete any letter that is locked or breaks rules; your AO3 email will be sent a courtesy notice. You may resubmit a fixed letter at any time!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Here are your requests formatted in HTML so you can easily share them - may we suggest posting to the\n        "),_c('a',{attrs:{"href":"https://yuletide.dreamwidth.org/139157.html#cutid1","target":"blank"}},[_vm._v("Letters Post")]),_vm._v("?\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aMsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['user-lookup', { collapsed: !_vm.user }]},[_c('div',{staticClass:"heading"},[_c('strong',[_vm._v(_vm._s(_vm.user)+"'s")]),_vm._v(" prompts")]),_vm._v(" "),_c('a',{attrs:{"href":'#/user/' + _vm.user,"target":"blank"}},[_vm._v("Permalink")]),_vm._v(" "),_c('a',{staticClass:"close-lookup",on:{"click":_vm.close}},[_vm._v("(x)")]),_vm._v(" "),(_vm.userPrompts.length)?[_c('table',{staticClass:"prompts"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.userPrompts),function(prompt){return _c('tr',[_c('td',[_c('button',{staticClass:"bookmark",on:{"click":function($event){_vm.togglePromptmark(prompt)}}},[(_vm.hasPromptmark(prompt))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})])]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(prompt.fandom)+"\n          ")]),_vm._v(" "),_c('td',[(prompt.characters)?_c('ul',{staticClass:"characters"},_vm._l((prompt.characters),function(c){return _c('li',[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"prompt"},[_c('div',{domProps:{"innerHTML":_vm._s(prompt.prompt)}}),_vm._v(" "),(prompt.letter)?_c('a',{attrs:{"href":_vm.formatUrl(prompt.letter),"target":"blank"}},[_vm._v("Letter")]):_vm._e()])])}))])]:_c('div',[_vm._v("User not found! Search is case-sensitive and preserves whitespace - maybe check your search and try again?.")])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"fave"},[_c('span',{staticClass:"fas fa-heart"})]),_vm._v(" "),_c('th',{staticClass:"username"},[_vm._v("Fandom")]),_vm._v(" "),_c('th',{staticClass:"characters"},[_vm._v("Characters")]),_vm._v(" "),_c('th',{staticClass:"prompts"},[_vm._v("Prompts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bFQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_letter_vue__ = __webpack_require__("txoR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d7ceab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_add_letter_vue__ = __webpack_require__("EKTE");
function injectStyle (ssrContext) {
  __webpack_require__("uMk4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59d7ceab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_letter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d7ceab_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_add_letter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cqMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_js__ = __webpack_require__("jyVo");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getUserPrompts(_this.$route.params.id);

            case 2:
              _this.loading = false;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    $route: function $route(to, from) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.getUserPrompts(_this2.$route.params.id);

              case 3:
                _this2.loading = false;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  data: function data() {
    return {
      loading: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['userPrompts', 'options'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_utils_js__["a" /* default */])
});

/***/ }),

/***/ "dVXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__("cqMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702099db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__("7PO5");
function injectStyle (ssrContext) {
  __webpack_require__("eVxJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702099db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eVxJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ghUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caveats"},[_c('small',[_vm._v("Caveats: human error may result in missing data; let us know if you see something weird.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jyVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__db_js__ = __webpack_require__("ueVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_lists__ = __webpack_require__("DSBJ");








/* harmony default export */ __webpack_exports__["a"] = ({
  getCharacters: function getCharacters(fandomKey) {
    var _this = this;

    var chars = this.characters[fandomKey];
    if (chars !== undefined) {
      return chars;
    }

    if (this.loadAll.characters) {
      return null;
    }

    __WEBPACK_IMPORTED_MODULE_5__db_js__["a" /* default */].ref('/characters/' + fandomKey).once('value').then(function (res) {
      var result = res.toJSON();
      _this.$store.commit('addChar', { key: fandomKey, result: result });
      return result;
    });
  },
  letterHasChar: function letterHasChar(key, char) {
    return this.letterChars.fandom === key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(this.letterChars.characters, char);
  },
  highlightChars: function highlightChars(letter, key) {
    this.letterChars = {
      fandom: key,
      characters: letter.characters
    };
  },
  getUserPrompts: function getUserPrompts(username) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.$store.commit('setUser', 'Loading');

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__db_js__["a" /* default */].ref('/users/' + username).once('value').then(function (snapshot) {
                var results = snapshot.val();

                _this2.$store.commit('setUser', username);

                if (results && results.length) {
                  _this2.$store.commit('setUserPrompts', results);
                } else {
                  _this2.$store.commit('setUserPrompts', []);
                }
              });

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  toggle: function toggle(fandom) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(this.bookmarks, fandom)) {
      this.remove(fandom);
      return false;
    }
    var newVal = this.bookmarks;
    newVal.push(fandom);
    this.$store.commit('setBookmarks', newVal);
    this.$localStorage.set('bookmarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.bookmarks));
  },
  toggleLettermark: function toggleLettermark(letter, fandom) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.lettermarks, function (o) {
      return o.username === letter.username && o.key === fandom['.key'];
    })) {
      this.removeLettermark(letter, fandom['.key']);
      return false;
    }

    var newVal = this.lettermarks;

    newVal.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, letter, {
      name: fandom.name,
      key: fandom['.key']
    }));

    this.$store.commit('setLettermarks', newVal);
    this.$localStorage.set('lettermarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.lettermarks));
  },
  togglePromptmark: function togglePromptmark(prompt) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.promptmarks, function (o) {
      return o.username === prompt.username && o.fandom === prompt.fandom;
    })) {
      this.removePromptmark(prompt);
      return false;
    }

    var newVal = this.promptmarks;
    newVal.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, prompt));

    this.$store.commit('setPromptmarks', newVal);
    this.$localStorage.set('promptmarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.promptmarks));
  },
  remove: function remove(fandom) {
    this.$store.commit('setBookmarks', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.bookmarks, function (o) {
      return o['.key'] !== fandom['.key'];
    }));
    this.$localStorage.set('bookmarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.bookmarks));
  },
  removeLettermark: function removeLettermark(letter, key) {
    if (!key && letter.key !== undefined) {
      key = letter.key;
    }

    this.$store.commit('setLettermarks', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.lettermarks, function (o) {
      return !(o.username === letter.username && o.key === key);
    }));
    this.$localStorage.set('lettermarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.lettermarks));
  },
  removePromptmark: function removePromptmark(prompt) {
    this.$store.commit('setPromptmarks', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(this.promptmarks, function (o) {
      return o.username !== prompt.username && o.fandom === prompt.fandom || o.fandom !== prompt.fandom;
    }));
    this.$localStorage.set('promptmarks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.promptmarks));
  },
  hasBookmark: function hasBookmark(fandom) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.bookmarks, function (o) {
      return o['.key'] === fandom['.key'];
    });
  },
  hasLettermark: function hasLettermark(letter, fandom) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.lettermarks, function (o) {
      return o.username === letter.username && o.key === fandom['.key'];
    });
  },
  hasPromptmark: function hasPromptmark(prompt) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(this.promptmarks, function (o) {
      return o.username === prompt.username && o.fandom === prompt.fandom;
    });
  },
  collapse: function collapse(length, e) {
    e.target.innerText = e.target.innerText !== 'Collapse' ? 'Collapse' : 'Expand (' + length + ')';
    e.target.nextElementSibling.classList.toggle('hide');
  },
  isProlific: function isProlific(name) {
    if (!this.showEasterEggs) {
      return false;
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(__WEBPACK_IMPORTED_MODULE_6__data_lists__["a" /* PROLIFIC_WRITERS */], name.trim().toLowerCase())) {
      return true;
    }

    return false;
  },
  challenges: function challenges(name) {
    if (!this.showEasterEggs) {
      return false;
    }

    var data = [];

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(this.crueltide, name.trim().toLowerCase()) ? data.push('C') : null;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(this.yuleporn, name.trim().toLowerCase()) ? data.push('P') : null;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(this.festivus, name.trim().toLowerCase()) ? data.push('F') : null;

    return data;
  },
  getPrompts: function getPrompts(fandomKey) {
    var _this3 = this;

    var newVal = this.prompts;
    newVal[fandomKey] = 'loading';
    this.$store.commit('setPrompts', {});
    this.$store.commit('setPrompts', newVal);

    __WEBPACK_IMPORTED_MODULE_5__db_js__["a" /* default */].ref('/prompts/' + fandomKey).once('value').then(function (snapshot) {
      var results = snapshot.val();

      if (results && results.length) {
        results = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["sortBy"])(results, function (o) {
          return o.username.toLowerCase();
        });
        newVal[fandomKey] = results;
      } else {
        newVal[fandomKey] = [];
      }

      _this3.$store.commit('setPrompts', {});
      _this3.$store.commit('setPrompts', newVal);
    });
  },
  formatUrl: function formatUrl(url) {
    if (!this.options.destyle || !url) {
      return url;
    }

    url = url.trim();

    var isDW = url.indexOf('dreamwidth.org') > -1;
    var isLJ = url.indexOf('livejournal.com') > -1;
    var isTumblr = url.indexOf('tumblr.com') > -1;
    var isDocs = url.indexOf('docs.google') > -1;

    if (isDW) {
      if (url.indexOf('?style=') === -1 && url.indexOf('&style=') === -1) {
        if (url.indexOf('?') > -1) {
          return url + '&style=site';
        }

        return url + '?style=site';
      }
    }

    if (isLJ) {
      if (url.indexOf('?style=') === -1 && url.indexOf('&style=') === -1 && url.indexOf('format=') === -1) {
        if (url.indexOf('?') > -1) {
          return url + '&format=light';
        }

        return url + '?format=light';
      }
    }

    if (isTumblr) {
      if (url.indexOf('/mobile') === -1) {
        return url + '/mobile';
      }
    }

    if (isDocs) {
      if (url.indexOf('/mobilebasic') === -1) {
        return url.replace(/\/edit.*$/, '') + '/mobilebasic';
      }
    }

    return url;
  }
});

/***/ }),

/***/ "lGKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Yuletide 2018 App")]),_vm._v(" "),(_vm.showHelp)?_c('help',{on:{"close":function($event){_vm.showHelp = false}}}):_vm._e(),_vm._v(" "),(!_vm.loaded || !_vm.loadedChars)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.loaded && _vm.loadedChars && !_vm.maintenance)?[_c('div',{staticClass:"scroll-top",on:{"click":_vm.scrollToTop}},[_vm._v("(^)")]),_vm._v(" "),_c('div',{class:['menu', { sticky: _vm.sticky }]},[_c('ul',[_c('li',{staticClass:"submit-letter",on:{"click":function($event){_vm.showLetterModal = true}}},[_vm._v("Submit Letter")]),_vm._v(" "),_c('li',{staticClass:"edit-letter",on:{"click":function($event){_vm.showEditModal = true}}},[_vm._v("Edit Letter")]),_vm._v(" "),_c('li',{staticClass:"bookmarks",on:{"click":function($event){_vm.expandBookmarks = !_vm.expandBookmarks}}},[_vm._v("Bookmarks")]),_vm._v(" "),_c('li',{staticClass:"help",on:{"click":function($event){_vm.showHelp = true}}},[_c('span',{staticClass:"fas fa-question-circle fa-xxl"})])])]),_vm._v(" "),_c('bookmarks',{attrs:{"force-expand":_vm.expandBookmarks},on:{"toggle":function($event){_vm.expandBookmarks = !_vm.expandBookmarks}}}),_vm._v(" "),(_vm.showLetterModal)?_c('add-letter',{on:{"close":function($event){_vm.showLetterModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showEditModal)?_c('edit-letter',{on:{"close":function($event){_vm.showEditModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showEggHelp)?_c('easter-eggs',{staticClass:"modal",on:{"hide":function($event){_vm.showEggHelp = false}}}):_vm._e(),_vm._v(" "),_c('user-lookup'),_vm._v(" "),_c('options'),_vm._v(" "),_c('table',{staticClass:"main"},[_c('thead',[_c('tr',[_c('th',{staticClass:"fandom"},[_vm._v("Fandom")]),_vm._v(" "),(!_vm.options.hideCharacters)?_c('th',{staticClass:"characters"},[_vm._v("Characters")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"letters"},[_vm._v("Letters")]),_vm._v(" "),(_vm.unlock)?_c('th',{staticClass:"prompts"},[_vm._v("Prompts")]):_vm._e()])]),_vm._v(" "),_c('tbody',[(_vm.updating)?_c('tr',{staticClass:"overlay"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.filtered),function(fandom,index){return (_vm.options.loadAll || index <= _vm.scrollPosition)?_c('tr',{key:index,class:{odd: index % 2 !== 0 }},[_c('td',{staticClass:"fandom",attrs:{"data-label":"Fandom"}},[_vm._v("\n            "+_vm._s(fandom.name)+"\n            "),_c('button',{staticClass:"bookmark",on:{"click":function($event){_vm.toggle(fandom)}}},[(_vm.hasBookmark(fandom))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})]),_vm._v(" "),_c('div',{staticClass:"meta"},[(_vm.maintenance)?_c('div',[_vm._v("Key: "+_vm._s(fandom['.key']))]):_vm._e(),_vm._v(" "),(!_vm.options.hideCategory)?_c('span',{staticClass:"category meta-tag"},[_vm._v(_vm._s(fandom.category.join(', ')))]):_vm._e()])]),_vm._v(" "),(!_vm.options.hideCharacters)?_c('td',{staticClass:"characters"},[_c('ul',_vm._l((_vm.getCharacters(fandom['.key'], 'char li')),function(char){return _c('li',{key:char,class:{ highlight: _vm.letterHasChar(fandom['.key'], char) }},[_vm._v(_vm._s(char))])}))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"letters"},[_c('ul',_vm._l((_vm.letters[fandom['.key']]),function(letter){return _c('li',{key:letter.username,staticClass:"letter"},[(letter.isPinchhitter)?[_vm._v("(")]:_vm._e(),_vm._v(" "),_c('a',{staticClass:"user",attrs:{"href":_vm.formatUrl(letter.url),"target":"_blank"}},[_vm._v(_vm._s(letter.username))]),_vm._v(" "),(letter.isPinchhitter)?[_vm._v(")")]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"bookmark-letter",on:{"click":function($event){_vm.toggleLettermark(letter, fandom)}}},[(_vm.hasLettermark(letter, fandom))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})]),_vm._v(" "),_c('div',{staticClass:"meta"},[(_vm.isProlific(letter.username))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showEasterEggs)?_c('sup',[_vm._v(_vm._s(_vm.challenges(letter.username).join(' ')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"char-count meta-tag",on:{"click":function($event){_vm.highlightChars(letter, fandom['.key'])},"mouseleave":function($event){_vm.letterChars = []}}},[_vm._v("Chars: "+_vm._s(letter.characters === undefined ? 'Any' : letter.characters.length))])])],2)}))]),_vm._v(" "),(_vm.unlock)?_c('td',{staticClass:"prompts"},[(!_vm.prompts[fandom['.key']] && _vm.hasPrompts[fandom['.key']])?_c('button',{staticClass:"button-primary",on:{"click":function($event){_vm.getPrompts(fandom['.key'])}}},[_vm._v("Get Prompts")]):_vm._e(),_vm._v(" "),(_vm.prompts[fandom['.key']] === 'loading')?_c('div',[_vm._v("Loading...")]):_vm._e(),_vm._v(" "),(_vm.prompts[fandom['.key']] && _vm.prompts[fandom['.key']].length && _vm.prompts[fandom['.key']] !== 'loading')?[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.collapse(_vm.prompts[fandom['.key']].length, $event)}}},[_vm._v("Collapse")]),_vm._v(" "),_c('table',{staticClass:"prompts"},[_vm._m(1,true),_vm._v(" "),_c('tbody',_vm._l((_vm.prompts[fandom['.key']]),function(prompt,index){return _c('tr',{key:index},[_c('td',[_c('button',{staticClass:"bookmark",on:{"click":function($event){_vm.togglePromptmark(prompt)}}},[(_vm.hasPromptmark(prompt))?_c('span',{staticClass:"fas fa-heart"}):_c('span',{staticClass:"far fa-heart"})])]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(prompt.username)+"\n                      "),(_vm.isProlific(prompt.username))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),(_vm.showEasterEggs)?_c('sup',[_vm._v(_vm._s(_vm.challenges(prompt.username).join(' ')))]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.getUserPrompts(prompt.username)}}},[_vm._v("(see all)")])]),_vm._v(" "),_c('td',[(prompt.characters)?_c('ul',{staticClass:"characters"},_vm._l((prompt.characters),function(c){return _c('li',{key:c},[_vm._v(_vm._s(c))])})):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"prompt"},[_c('div',{domProps:{"innerHTML":_vm._s(prompt.prompt)}}),_vm._v(" "),(prompt.letter)?_c('a',{attrs:{"href":_vm.formatUrl(prompt.letter),"target":"blank"}},[_vm._v("Letter")]):_vm._e()])])}))])]:(!_vm.hasPrompts[fandom['.key']])?_c('span',[_vm._v("No prompts ):")]):_vm._e()],2):_vm._e()]):_vm._e()})],2)]),_vm._v(" "),_c('caveats')]:_c('maintenance')],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"fave"},[_c('span',{staticClass:"fas fa-heart"})]),_vm._v(" "),_c('th',{staticClass:"username"},[_vm._v("Username")]),_vm._v(" "),_c('th',{staticClass:"characters"},[_vm._v("Characters")]),_vm._v(" "),_c('th',{staticClass:"prompts"},[_vm._v("Prompts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},[_c('div',{staticClass:"filters row"},[_c('span',{staticClass:"label"},[_vm._v("Filter By:")]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.filter.term),expression:"options.filter.term"}],attrs:{"id":"fandom-filter","type":"text","placeholder":"Fandom name..."},domProps:{"value":(_vm.options.filter.term)},on:{"input":function($event){if($event.target.composing){ return; }_vm.options.filter.term=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.filter.category),expression:"options.filter.category"}],attrs:{"id":"category-filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.options.filter.category=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("All Categories")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('option',{key:category},[_vm._v(_vm._s(category))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("Show Only:")]),_vm._v(" "),(_vm.unlock)?_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.onlyPrompts),expression:"options.onlyPrompts"}],attrs:{"type":"checkbox","id":"prompts-fandoms"},domProps:{"checked":Array.isArray(_vm.options.onlyPrompts)?_vm._i(_vm.options.onlyPrompts,null)>-1:(_vm.options.onlyPrompts)},on:{"__c":function($event){var $$a=_vm.options.onlyPrompts,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.onlyPrompts=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.onlyPrompts=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.onlyPrompts=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"prompts-fandoms"}},[_vm._v("Fandoms with prompts")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.onlyBookmarks),expression:"options.onlyBookmarks"}],attrs:{"type":"checkbox","id":"bookmarked-fandoms"},domProps:{"checked":Array.isArray(_vm.options.onlyBookmarks)?_vm._i(_vm.options.onlyBookmarks,null)>-1:(_vm.options.onlyBookmarks)},on:{"__c":function($event){var $$a=_vm.options.onlyBookmarks,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.onlyBookmarks=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.onlyBookmarks=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.onlyBookmarks=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"bookmarked-fandoms"}},[_vm._v("Bookmarked fandoms")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.onlyLetters),expression:"options.onlyLetters"}],attrs:{"type":"checkbox","id":"letters-fandoms"},domProps:{"checked":Array.isArray(_vm.options.onlyLetters)?_vm._i(_vm.options.onlyLetters,null)>-1:(_vm.options.onlyLetters)},on:{"__c":function($event){var $$a=_vm.options.onlyLetters,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.onlyLetters=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.onlyLetters=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.onlyLetters=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"letters-fandoms"}},[_vm._v("\n        Fandoms with letters\n        "),(_vm.unlock)?_c('span',[_vm._v("*")]):_vm._e()])]),_vm._v(" "),(_vm.unlock)?_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.onlyPHs),expression:"options.onlyPHs"}],attrs:{"type":"checkbox","id":"ph"},domProps:{"checked":Array.isArray(_vm.options.onlyPHs)?_vm._i(_vm.options.onlyPHs,null)>-1:(_vm.options.onlyPHs)},on:{"__c":function($event){var $$a=_vm.options.onlyPHs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.onlyPHs=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.onlyPHs=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.onlyPHs=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"ph"}},[_vm._v("Fandoms with (pinch-hitters) who did not sign up")])]):_vm._e()]),_vm._v(" "),(_vm.unlock)?_c('div',{staticClass:"row clear"},[_c('small',[_vm._v("* letters that were submitted to the letters post; prompts may have unlisted letters")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("Tools:")]),_vm._v(" "),(!_vm.loadAll.characters)?_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.loadAll),expression:"options.loadAll"}],attrs:{"type":"checkbox","id":"load-all"},domProps:{"checked":Array.isArray(_vm.options.loadAll)?_vm._i(_vm.options.loadAll,null)>-1:(_vm.options.loadAll)},on:{"__c":function($event){var $$a=_vm.options.loadAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.loadAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.loadAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.loadAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"load-all"}},[_vm._v("Load everything!")]),_vm._v(" "),_c('sup',[_c('span',{staticClass:"fas fa-exclamation-circle warn",on:{"click":function($event){_vm.showMsg = !_vm.showMsg}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.hideCharacters),expression:"options.hideCharacters"}],attrs:{"type":"checkbox","id":"hide-chars"},domProps:{"checked":Array.isArray(_vm.options.hideCharacters)?_vm._i(_vm.options.hideCharacters,null)>-1:(_vm.options.hideCharacters)},on:{"__c":function($event){var $$a=_vm.options.hideCharacters,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.hideCharacters=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.hideCharacters=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.hideCharacters=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"hide-chars"}},[_vm._v("Hide Characters")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.options.destyle),expression:"options.destyle"}],attrs:{"type":"checkbox","id":"journal-style"},domProps:{"checked":Array.isArray(_vm.options.destyle)?_vm._i(_vm.options.destyle,null)>-1:(_vm.options.destyle)},on:{"__c":function($event){var $$a=_vm.options.destyle,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.options.destyle=$$a.concat([$$v]))}else{$$i>-1&&(_vm.options.destyle=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.options.destyle=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"journal-style"}},[_vm._v("Mobile letter format")])]),_vm._v(" "),(_vm.showMsg)?_c('div',{staticClass:"clear"},[_c('small',[_c('strong',{style:({ color: 'red'})},[_vm._v("Load all the fandoms at once instead of as you scroll. This may take your browser a bit!")])])]):_vm._e()]),_vm._v(" "),(_vm.unlock)?_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("Username:")]),_vm._v(" "),_c('div',{staticClass:"option-large"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userlookup),expression:"userlookup"}],attrs:{"id":"search-user","type":"text","placeholder":"AO3 Username"},domProps:{"value":(_vm.userlookup)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userlookup=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"button-primary search-user-submit",on:{"click":function($event){_vm.getUserPrompts(_vm.userlookup)}}},[_vm._v("Go!")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oV5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "q+oP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb6260a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_vue__ = __webpack_require__("xcKl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb6260a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_maintenance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qA4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([true, true, false, true, true, true, true, true, false, true, false, true, true, true, true, true, false, false, false, false, true, true, true, false, false, true, false, false, true, true, false, false, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, true, false, false, true, false, true, false, false, true, true, true, true, true, false, true, true, true, false, true, true, false, false, true, true, false, true, true, true, false, false, true, true, false, true, true, false, false, true, false, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, false, true, true, false, false, false, true, true, true, true, true, true, true, false, true, true, true, true, false, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, true, true, true, false, true, true, false, true, true, true, true, false, true, true, true, false, true, false, false, false, true, false, false, true, true, false, false, false, true, true, false, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, false, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, false, true, true, false, false, true, false, true, true, true, false, true, false, false, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, false, false, true, true, true, true, false, true, true, true, true, true, false, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, false, true, true, true, false, true, true, true, false, false, true, true, false, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, false, true, false, true, true, true, true, false, true, true, false, true, false, false, true, true, false, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, false, false, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, false, true, true, true, false, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, false, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, true, true, false, true, false, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, false, true, false, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, true, true, false, true, true, true, true, false, true, false, true, true, true, true, false, true, true, true, false, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, false, false, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, false, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, true, false, true, true, true, true, true, true, true, true, true, false, false, false, true, true, true, true, false, true, true, true, false, true, true, true, false, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, true, true, true, true, false, true, true, true, false, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, false, false, true, true, false, true, false, false, true, true, false, true, false, true, true, false, false, false, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, false, false, true, false, false, true, true, true, false, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, false, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, false, false, true, true, false, true, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, false, false, true, true, true, true, true, false, true, false, true, false, true, false, true, true, false, true, true, true, true, true, false, true, false, false, true, false, true, true, false, true, true, true, true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, true, true, false, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, false, true, false, true, true, false, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, false, true, false, true, false, false, true, false, false, true, true, true, true, true, false, false, true, false, true, true, false, false, true, true, false, false, true, true, true, true, true, false, false, true, true, false, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, false, true, true, false, true, true, false, false, true, true, true, true, true, false, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, false, false, true, true, true, false, false, true, false, true, true, true, false, false, true, true, true, false, false, true, true, true, false, false, true, true, true, true, false, true, false, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, false, false, false, true, false, true, true, true, false, true, true, true, false, false, false, true, true, false, true, true, true, true, false, true, true, true, false, false, true, true, false, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, false, true, true, true, true, false, false, true, false, false, true, true, true, false, true, true, true, true, false, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, true, true, false, true, false, true, false, true, true, true, true, true, true, false, true, true, false, false, true, true, false, true, true, true, false, true, true, false, false, true, false, true, true, true, true, false, true, true, false, true, true, true, true, true, false, true, false, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, false, true, true, true, false, true, true, false, false, true, true, true, true, true, true, true, true, true, false, true, false, false, true, true, true, true, false, true, false, false, false, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, false, true, true, true, true, true, false, true, true, false, true, true, false, false, true, true, false, true, false, true, true, false, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, true, false, false, true, true, false, true, true, false, false, false, true, true, true, true, true, true, false, false, true, true, false, true, false, true, true, true, false, true, true, true, true, true, true, true, false, false, true, false, true, true, false, true, true, false, true, true, true, false, true, true, true, false, true, true, false, true, false, false, true, false, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, false, false, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, false, true, true, true, false, true, true, true, false, false, true, false, true, true, true, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, false, true, true, true, true, true, true, true, true, true, false, false, false, true, true, true, true, false, true, true, true, true, true, true, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, false, false, true, true, false, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, false, false, true, false, false, false, false, false, true, true, true, true, false, true, true, true, false, false, true, true, false, true, true, true, false, true, false, true, true, true, true, true, false, false, true, true, true, false, false, true, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, false, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, false, true, true, true, false, false, false, true, false, true, false, true, true, true, true, true, true, false, true, false, false, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, false, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, false, true, true, true, true, true, true, false, true, true, true, false, false, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, false, false, true, true, false, true, false, true, true, true, true, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, false, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, true, true, true, false, true, false, true, false, true, true, true, false, true, true, true, true, false, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, false, true, true, false, false, false, true, true, true, true, true, false, false, true, true, true, true, true, false, true, false, false, true, true, false, true, true, false, false, false, false, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, true, false, false, false, true, true, false, true, true, false, false, false, true, true, false, false, false, true, false, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, false, true, false, true, false, true, true, true, true, true, false, false, true, true, true, false, true, false, false, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, false, false, true, true, false, true, true, true, false, true, true, true, true, false, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, true, true, false, true, true, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, false, false, true, true, true, false, false, true, true, true, false, true, true, true, true, false, true, true, true, true, true, true, true, false, false, true, true, true, false, false, true, false, true, true, true, true, true, true, false, true, false, true, true, true, true, true, true, false, false, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, false, false, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, true, false, true, false, true, false, true, true, true, true, false, false, true, true]);

/***/ }),

/***/ "qAyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fandom-autocomplete"},[_c('label',{class:{ error: _vm.hasError },attrs:{"for":"fandom"}},[_vm._v("Fandom "+_vm._s(_vm.number)+":")]),_vm._v(" "),(_vm.fandom.name)?_c('span',[_vm._v("\n    "+_vm._s(_vm.fandom.name)+"\n    "),_c('button',{staticClass:"remove",on:{"click":_vm.removeFandom}},[_c('span',{staticClass:"far fa-times-circle"})])]):_vm._e(),_vm._v(" "),(!_vm.fandom.name)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],attrs:{"type":"text","placeholder":"Search..."},domProps:{"value":(_vm.term)},on:{"keyup":_vm.autocomplete,"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.stopPropagation();_vm.select($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.next($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.prev($event)}],"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}}),_vm._v(" "),(_vm.options.length)?_c('div',[_vm._m(0),_vm._v(" "),_vm._l((_vm.options),function(option,i){return _c('span',{key:option['.key'],class:['option', { focused: i === _vm.selectedIndex }],domProps:{"innerHTML":_vm._s(_vm.highlight(option.name, 'f'))},on:{"mouseenter":function($event){_vm.selectedIndex = i},"mouseleave":function($event){_vm.selectedIndex = -1},"click":_vm.select}})})],2):_vm._e()]:_c('div',[_c('label',{attrs:{"for":"chars"}},[_vm._v("Characters:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],attrs:{"type":"text","placeholder":"Filter..."},domProps:{"value":(_vm.term)},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }$event.preventDefault();_vm.select('char')},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40)){ return null; }_vm.next($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38)){ return null; }_vm.prev($event)}],"keyup":_vm.autocomplete,"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"badges"},_vm._l((_vm.chars),function(char){return _c('span',{staticClass:"character"},[_vm._v("\n        "+_vm._s(char)+"\n        "),_c('button',{staticClass:"remove",on:{"click":function($event){_vm.removeChar(char)}}},[_c('span',{staticClass:"far fa-times-circle"})])])})),_vm._v(" "),(_vm.charsLoading)?_c('p',[_vm._v("Loading character options...")]):_vm._e(),_vm._v(" "),(Object.keys(_vm.options).length && _vm.chars && _vm.chars.length < _vm.maxChars)?_c('div',[_vm._m(1),_vm._v(" "),_vm._l((_vm.options),function(option,i){return _c('span',{key:option,class:['option', { focused: i === _vm.selectedIndex }],domProps:{"innerHTML":_vm._s(_vm.highlight(option, 'c'))},on:{"mouseenter":function($event){_vm.selectedIndex = i},"mouseleave":function($event){_vm.selectedIndex = -1},"click":function($event){_vm.select('char')}}})})],2):(Object.keys(_vm.options).length === 0 && !_vm.chars.length)?_c('p',[_vm._v("No characters were nominated")]):_vm._e()]),_vm._v(" "),(_vm.msg)?_c('p',{staticClass:"msg"},[_vm._v(" "+_vm._s(_vm.msg))]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("Available options:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("Available options:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qSma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__db_js__ = __webpack_require__("ueVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_js__ = __webpack_require__("jyVo");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['unlock', 'categories', 'loadAll'])),
  watch: {
    options: {
      handler: function handler(val, oldVal) {
        var _this = this;

        if (val.filter.term.length && val.filter.term === oldVal.filter.term) {
          __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
            if (val.onlyPHs) {
              _this.options.onlyPrompts = false;
              val.onlyPrompts = false;
            }
            _this.$store.commit('setOptions', val);
          }, 500)();
        } else {
          if (val.onlyPHs) {
            this.options.onlyPrompts = false;
            val.onlyPrompts = false;
          }
          this.$store.commit('setOptions', val);
        }
      },

      deep: true
    }
  },
  methods: {
    getUserPrompts: __WEBPACK_IMPORTED_MODULE_4__utils_js__["a" /* default */].getUserPrompts
  },
  data: function data() {
    return {
      showMsg: false,
      userlookup: '',
      options: {
        filter: {
          category: '',
          term: ''
        },
        onlyLetters: false,
        onlyBookmarks: false,
        onlyPrompts: true,
        onlyPHs: false,
        destyle: false,
        loadAll: false,
        hideCharacters: true
      }
    };
  }
});

/***/ }),

/***/ "r5+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_hasPrompts_js__ = __webpack_require__("qA4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__("jyVo");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  beforeMount: function beforeMount() {
    var _this = this;

    var data = [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.bookmarks, function (o) {
      var fandom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(_this.fandoms, function (fandom) {
        return fandom['.key'] === o['.key'];
      });

      if (fandom) {
        data.push(fandom);
      }
    });

    this.bookmarksData = data;
  },

  watch: {
    bookmarks: function bookmarks() {
      var _this2 = this;

      var data = [];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.bookmarks, function (o) {
        var fandom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(_this2.fandoms, function (fandom) {
          return fandom['.key'] === o['.key'];
        });

        if (fandom) {
          data.push(fandom);
        }
      });

      this.bookmarksData = data;
    },
    forceExpand: function forceExpand(val) {
      this.expand = val;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['letters', 'options', 'fandoms', 'bookmarks', 'characters', 'promptmarks', 'lettermarks', 'prompts', 'unlock', 'showEasterEggs', 'loadAll']), {
    marks: function marks() {
      var marks = {
        fandoms: this.bookmarks,
        letters: this.lettermarks,
        prompts: this.promptsmarks
      };

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(marks);
    }
  }),
  props: {
    forceExpand: false
  },
  data: function data() {
    return {
      letterChars: [],
      hasPrompts: __WEBPACK_IMPORTED_MODULE_3__data_hasPrompts_js__["a" /* default */],
      showHelp: false,
      expand: false,
      bookmarksData: [],
      largeBookmarks: false,
      saved: null,
      showLoad: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__utils_js__["a" /* default */], {
    loadSaved: function loadSaved() {

      if (!confirm('Are you sure you want to load bookmarks? Your current bookmarks will be wiped!')) {
        return;
      }

      var parsed = void 0;

      try {
        parsed = JSON.parse(this.saved);
      } catch (e) {
        alert('Your bookmarks were invalid!');
        return;
      }

      if (!this.saved || !this.saved.length) {
        return;
      }
      this.$localStorage.set('lettermarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parsed.letters));
      this.$localStorage.set('bookmarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parsed.fandoms));
      this.$localStorage.set('promptmarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parsed.prompts || []));
      this.$store.commit('setPromptmarks', parsed.prompts || []);
      this.$store.commit('setBookmarks', parsed.fandoms);
      this.$store.commit('setLettermarks', parsed.letters);
    }
  })
});

/***/ }),

/***/ "rvjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_letter_vue__ = __webpack_require__("60tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74074940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_edit_letter_vue__ = __webpack_require__("TWSu");
function injectStyle (ssrContext) {
  __webpack_require__("G7wP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74074940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_letter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74074940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_edit_letter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "txoR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fandom_autocomplete_vue__ = __webpack_require__("7RSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__db_js__ = __webpack_require__("ueVu");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FandomAutocomplete: __WEBPACK_IMPORTED_MODULE_5__fandom_autocomplete_vue__["a" /* default */]
  },
  firebase: {
    letters: __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letters')
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  beforeMount: function beforeMount() {
    this.availableFandoms = this.fandoms;
  },
  data: function data() {
    return {
      errors: [],
      max: 6,
      min: 3,
      isPinchhitter: false,
      username: '',
      selectedFandoms: [],
      scrubbedFandoms: [],
      url: '',
      isReview: false,
      availableFandoms: [],
      userExists: false,
      showSubmit: true,
      userKey: '',
      number: undefined
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['fandoms']), {
    submitText: function submitText() {
      if (this.isReview) {
        return 'Submit!';
      }

      return 'Preview!';
    }
  }),
  methods: {
    // https://stackoverflow.com/questions/8667070/javascript-regular-expression-to-validate-url
    validateUrl: function validateUrl(value) {
      return (/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value)
      );
    },
    submit: function submit() {
      this.errors = [];
      this.scrubFandoms();

      if (this.isReview) {
        this.add();
        return;
      }

      if (!this.username.length) {
        this.errors.push('username');
      }

      if (!this.url.length || !this.validateUrl(this.url)) {
        this.errors.push('url');
      }

      if (!this.isPinchhitter && this.scrubbedFandoms.length < this.min) {
        this.errors.push('fandom');
      }

      if (this.errors.length) {
        return;
      }

      this.isReview = true;
    },
    scrubFandoms: function scrubFandoms() {
      // put things into a separate array so that index order is preserved
      // if users want to go back and edit
      this.scrubbedFandoms = _.compact(_.filter(this.selectedFandoms, function (f) {
        return f !== null && f !== undefined;
      }));
    },
    edit: function edit() {
      this.isReview = false;
    },
    hasError: function hasError(type) {
      return _.includes(this.errors, type);
    },
    update: function update(index, data) {
      var newVal = this.selectedFandoms;

      if (!data.fandom || !data.fandom.name) {
        newVal[index] = null;
      } else {
        newVal[index] = data;
      }

      this.selectedFandoms = [];
      this.selectedFandoms = newVal;

      var selected = [];

      _.each(this.selectedFandoms, function (o) {
        if (!o) {
          return;
        }
        selected.push(o.fandom['.key']);
      });

      this.availableFandoms = _.filter(this.fandoms, function (o) {
        return !_.includes(selected, o['.key']);
      });
    },
    getCopypasta: function getCopypasta() {
      if (!this.scrubbedFandoms.length) {
        return;
      }

      var pasta = ['<p><strong>' + this.username + '</strong><br>' + this.url + '</p>'];

      _.each(this.scrubbedFandoms, function (f) {
        var fandom = f.fandom;
        var chars = f.characters;
        if (!chars.length) {
          chars = ['Any (see tagset)'];
        }
        var s = '<p><strong>' + fandom.name + '</strong><br>' + chars.join(', ') + '</p>';

        pasta.push(s);
      });

      return pasta.join('\n');
    },
    add: function add() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(_this.username).once('value').then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (res.val()) {
                              _context.next = 9;
                              break;
                            }

                            _this.userKey = (Math.random() + 1).toString(36).substring(7);
                            _this.showSubmit = false;

                            __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(_this.username).set({ key: _this.userKey, timestamp: new Date().toISOString() });

                            _.each(_this.scrubbedFandoms, function (req) {
                              _this.$firebaseRefs.letters.child(req.fandom['.key']).child(_this.username).set({
                                username: _this.username,
                                url: _this.url,
                                characters: req.characters,
                                isPinchhitter: _this.isPinchhitter || false
                              });

                              __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').child(_this.username).child('fandoms').child(req.fandom['.key']).set({
                                url: _this.url,
                                key: req.fandom['.key'],
                                characters: req.characters,
                                isPinchhitter: _this.isPinchhitter || false
                              });
                            });

                            _context.next = 7;
                            return __WEBPACK_IMPORTED_MODULE_6__db_js__["a" /* default */].ref('/letterkeys').once('value').then(function (res) {
                              _this.number = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.val()).length;
                            });

                          case 7:
                            _context.next = 12;
                            break;

                          case 9:
                            _this.userExists = true;
                            _this.showSubmit = false;
                            return _context.abrupt('return');

                          case 12:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "uMk4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ueVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__("OPUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__("X2NH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_database__);



// require('firebase/database');

var firebaseApp = void 0;
if (!__WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.apps.length) {
  firebaseApp = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */]);
} else {
  firebaseApp = __WEBPACK_IMPORTED_MODULE_1_firebase_app___default.a.app();
}

var db = firebaseApp.database();

/* harmony default export */ __webpack_exports__["a"] = (db);

/***/ }),

/***/ "vGNL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v("You've "+_vm._s(_vm.showEasterEggs ? 'enabled' : 'disabled')+" easter eggs! Press F1 again to toggle.")]),_vm._v(" "),_c('strong',[_vm._v("Stats:")]),_vm._v(" "),_c('p',[_vm._v("\n      Fandoms with letters: "+_vm._s(_vm.totalLetters)+"\n    ")]),_vm._v(" "),_c('p',[_vm._v("No other easter eggs available this year, sorry! ):")]),_vm._v(" "),_c('button',{staticClass:"cancel",on:{"click":function($event){_vm.$emit('hide')}}},[_vm._v("(Got it)")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_add_letter_vue__ = __webpack_require__("bFQz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_edit_letter_vue__ = __webpack_require__("rvjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_bookmarks_vue__ = __webpack_require__("/wb9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_caveats_vue__ = __webpack_require__("EolY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_easter_eggs_vue__ = __webpack_require__("8/lm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_help_vue__ = __webpack_require__("+23j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_maintenance_vue__ = __webpack_require__("q+oP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_options_vue__ = __webpack_require__("6Jtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_user_lookup_vue__ = __webpack_require__("L1D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__db_js__ = __webpack_require__("ueVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_hasPrompts_js__ = __webpack_require__("qA4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_utils_js__ = __webpack_require__("jyVo");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: pinchitters










// third party




// internal



// Remove english articles from fandom names
function removeArticlesCompare(o) {
  if (!o) {
    return;
  }
  var regex = /^(the\s|a\s|an\s)/i;
  if (!o.name) {
    return o;
  }
  return o.name.toLowerCase().replace(regex, '');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    AddLetter: __WEBPACK_IMPORTED_MODULE_3__components_add_letter_vue__["a" /* default */],
    EditLetter: __WEBPACK_IMPORTED_MODULE_4__components_edit_letter_vue__["a" /* default */],
    Bookmarks: __WEBPACK_IMPORTED_MODULE_5__components_bookmarks_vue__["a" /* default */],
    Caveats: __WEBPACK_IMPORTED_MODULE_6__components_caveats_vue__["a" /* default */],
    EasterEggs: __WEBPACK_IMPORTED_MODULE_7__components_easter_eggs_vue__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_8__components_help_vue__["a" /* default */],
    Maintenance: __WEBPACK_IMPORTED_MODULE_9__components_maintenance_vue__["a" /* default */],
    Options: __WEBPACK_IMPORTED_MODULE_10__components_options_vue__["a" /* default */],
    UserLookup: __WEBPACK_IMPORTED_MODULE_11__components_user_lookup_vue__["a" /* default */]
  },
  beforeMount: function beforeMount() {
    this.$store.commit('setUnlock', true);
    this.$store.commit('setOptions', {
      filter: {
        category: '',
        term: ''
      },
      onlyLetters: false,
      onlyBookmarks: false,
      onlyPrompts: true,
      onlyPHs: false,
      destyle: false,
      hideCharacters: true
    });

    var bookmarksJson = this.$localStorage.get('bookmarks');
    if (bookmarksJson) {
      this.$store.commit('setBookmarks', JSON.parse(bookmarksJson));
    }

    var lettermarksJson = this.$localStorage.get('lettermarks');
    if (lettermarksJson) {
      this.$store.commit('setLettermarks', JSON.parse(lettermarksJson));
    }

    var promptmarksJson = this.$localStorage.get('promptmarks');
    if (promptmarksJson) {
      this.$store.commit('setPromptmarks', JSON.parse(promptmarksJson));
    }
  },
  created: function created() {
    document.addEventListener('keydown', this.easterEggs);
    document.addEventListener('keydown', this.unlockModTools);
    document.addEventListener('keyup', this.unlockModTools);
    window.addEventListener('scroll', this.lazyload);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.easterEggs);
    document.removeEventListener('keydown', this.unlockModTools);
    document.removeEventListener('keyup', this.unlockModTools);
    window.removeEventListener('scroll', this.lazyload);
  },
  data: function data() {
    return {
      showLetterModal: false,
      showEditModal: false,
      maintenance: false,
      showEggHelp: false,
      showHelp: false,
      hasPrompts: __WEBPACK_IMPORTED_MODULE_15__data_hasPrompts_js__["a" /* default */],
      expandBookmarks: false,
      down: {},
      mods: false,
      scrollPosition: 100,
      letterChars: {
        fandom: '',
        characters: []
      },
      timesCalled: 0,
      filtered: [],
      updating: true,
      sticky: false,
      promptStates: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    lastUpdated: function lastUpdated() {
      var data = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.find(this.meta, { '.key': 'lastUpdated' });

      if (!data) {
        return '';
      }

      return new Date(data['.value']).toString();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapGetters */])(['letters', 'fandoms', 'loaded', 'bookmarks', 'characters', 'categories', 'lettermarks', 'promptmarks', 'unlock', 'options', 'user', 'prompts', 'showEasterEggs', 'loadedChars', 'loadAll'])),
  watch: {
    letters: {
      deep: true,
      handler: function handler(val) {
        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(val).length) {
          return;
        }
        var scrubbed = this.scrubLettermarks(this.lettermarks, val);
        this.$store.commit('setLettermarks', scrubbed);
        this.$localStorage.set('lettermarks', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(scrubbed));
      }
    },
    options: {
      deep: true,
      handler: function handler(val) {
        var _this = this;

        this.updating = true;
        if ((val.loadAll || val.onlyLetters || val.onlyBookmarks) && !this.loadAll.characters) {
          var data = __WEBPACK_IMPORTED_MODULE_13__db_js__["a" /* default */].ref('/characters').orderByKey().startAt(String(0)).endAt(String(this.fandoms.length - 1)).once('value').then(function (res) {
            var backFill = res.val();
            // TODO: backfill null values in JSON in chars that should exist in fandoms
            // so that the characters database.length === fandoms.length
            var newVal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.characters, backFill);
            _this.$store.commit('loadAllChars', true);
            _this.$store.commit('setCharacters', {});
            _this.$store.commit('setCharacters', newVal);
            _this.scrollPosition = _this.fandoms.length;
            _this.updateFilter();
            return;
          });
        } else {
          this.updateFilter();
        }
      }
    },
    loaded: function loaded() {
      this.updateFilter();
    },
    scrollPosition: function scrollPosition(val) {
      if (val >= this.fandoms.length) {
        return;
      }
      this.updateFilter();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_16__components_utils_js__["a" /* default */], {
    updateFilter: function updateFilter() {
      var _this2 = this;

      this.updating = true;

      if (!this.options.onlyLetters && !this.options.onlyPrompts && !this.options.filter.term.length && !this.options.onlyBookmarks && !this.options.onlyPHs && !this.options.filter.category.length) {
        this.filtered = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.take(__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.sortBy(this.fandoms, ['category', removeArticlesCompare]), this.scrollPosition);
        setTimeout(function () {
          _this2.updating = false;
        }, 200);
      }

      var arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(this.fandoms, function (f) {
        return f.name.length;
      });

      if (this.options.onlyPrompts) {
        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return _this2.hasPrompts[o['.key']];
        });
      }

      if (this.options.onlyLetters) {
        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return _this2.letters[o['.key']] !== undefined;
        });
      }

      if (this.options.onlyBookmarks) {
        var bookmarkedFandoms = [];
        __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.each(this.bookmarks, function (b) {
          bookmarkedFandoms.push(b['.key']);
        });

        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.includes(bookmarkedFandoms, o['.key']);
        });
      }

      if (this.options.filter.category.length) {
        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.includes(o.category, _this2.options.filter.category);
        });
      }

      if (this.options.filter.term.length) {
        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return o.name.toLowerCase().indexOf(_this2.options.filter.term.toLowerCase()) > -1;
        });
      }

      if (this.options.onlyPHs) {
        arr = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(arr, function (o) {
          return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(_this2.letters[o['.key']], function (l) {
            return l.isPinchhitter;
          }).length;
        });
      }

      // If filtering by term or category, preload everything if there are more than a few
      // Also sort by alpha name instead of alpha category when there is a search term
      if ((this.options.filter.term.length || this.options.filter.category.length) && !this.loadAll.characters && arr.length > 5) {
        var data = __WEBPACK_IMPORTED_MODULE_13__db_js__["a" /* default */].ref('/characters').orderByKey().startAt(String(0)).endAt(String(this.fandoms.length - 1)).once('value').then(function (res) {
          var backFill = res.val();
          // TODO: backfill null values in JSON in chars that should exist in fandoms
          // so that the characters database.length === fandoms.length
          var newVal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this2.characters, backFill);
          _this2.$store.commit('loadAllChars', true);
          _this2.$store.commit('setCharacters', {});
          _this2.$store.commit('setCharacters', newVal);
          _this2.scrollPosition = _this2.fandoms.length;
          _this2.filtered = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.sortBy(arr, [removeArticlesCompare]);
          setTimeout(function () {
            _this2.updating = false;
          }, 200);
        });
        // Otherwise, just take the i/o hit
      } else if (this.options.filter.term.length || this.options.filter.category.length) {
        this.filtered = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.take(__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.sortBy(arr, [removeArticlesCompare]), this.scrollPosition);
        setTimeout(function () {
          _this2.updating = false;
        }, 200);
      } else {
        this.filtered = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.take(__WEBPACK_IMPORTED_MODULE_12_lodash___default.a.sortBy(arr, ['category', removeArticlesCompare]), this.scrollPosition);
        setTimeout(function () {
          _this2.updating = false;
        }, 200);
      }
    },
    lazyload: function lazyload() {
      var _this3 = this;

      var y = window.scrollY;
      var totalHeight = document.body.scrollHeight;

      if (window.pageYOffset > 100) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }

      if (this.loadAll.characters) {
        return;
      }

      if (totalHeight - y - (document.documentElement.scrollTop || document.body.scrollTop) < 50) {
        if (this.scrollPosition < this.fandoms.length) {
          var prevPosition = this.scrollPosition + 1 || 101;
          var newPosition = this.scrollPosition + 100;

          var data = __WEBPACK_IMPORTED_MODULE_13__db_js__["a" /* default */].ref('/characters').orderByKey().startAt(String(prevPosition)).endAt(String(newPosition)).once('value');

          data.then(function (res) {
            var backFill = res.val();
            var newVal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this3.characters, backFill);
            _this3.$store.commit('setCharacters', {});
            _this3.$store.commit('setCharacters', newVal);
            _this3.scrollPosition = newPosition;
          });
        }
      }
    },
    collapse: function collapse(length, e) {
      e.target.innerText = e.target.innerText !== 'Collapse' ? 'Collapse' : 'Expand (' + length + ')';
      e.target.nextElementSibling.classList.toggle('hide');
    },
    unlockModTools: function unlockModTools(e) {
      if (e.type === 'keydown') {
        this.down[e.keyCode] = true;

        // shift + 1 + 2
        if (this.down[16] && this.down[49] && this.down[50]) {
          this.mods = !this.mods;
        }
      }

      if (e.type === 'keyup') {
        this.down[e.keyCode] = false;
      }
    },

    // show easter eggs on F1
    easterEggs: function easterEggs(e) {
      if (e.keyCode !== 112) {
        return;
      }

      this.$store.commit('setEggs', !this.showEasterEggs);
      this.showEggHelp = true;
    },

    // utilities
    scrollToTop: function scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    // scrub bookmarks in case letters have changed
    scrubLettermarks: function scrubLettermarks(lettermarks, letters) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.filter(lettermarks, function (l) {
        var fandom = letters[l.key]; //[l.username];
        return l && fandom && fandom[l.username];
      });
    }
  })
});

/***/ }),

/***/ "xcKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y0XD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yRo+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.60524159e129cc12f4b9.js